import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButton } from '@angular/material/button';

export interface ErrorAction {
  title: string;
  handler: () => void;
}

export interface ErrorInfo {
  code: string;
  message: string;
  details: string;
  actions?: ErrorAction[];
}

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class ErrorPageComponent {
  readonly error = input<ErrorInfo>(undefined);
}
